import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import popupStyle from './../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import GlobalButton from '../../../../../utility/globalButton/button'
import Required from '../../../../../utility/required'
import styles from './../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import FieldsListOption from './fieldsListOption'
import PayloadFieldTable from './payloadFieldTable'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext'
import IconsColor from '../../../../../utility/iconsColor'
import textStyles from './../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss';
import globalStyles from '../../../../../../assets/styles/global.module.scss';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext'
import { whatsappTemplateButton, whatsAppWebhookPayloadKey } from '../../../../../../models/axiosModel'
import { generateUUID, WHATSAPP_WEBHOOK_PAYLOAD_KEY_TYPES } from '../../../../../../utils/constants'
import { isCurrentViewVersionPublished } from '../../../utilityFunctions'
import { UserContext, UserContextPayload } from '../../../../../../context/userContext'
import { useGenericStore } from '../../../../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'
import { TEMPLATE_TYPES } from '../../../../channels/global/whatsapp/templates/utils'
import { ACTION_TYPE_NAME, isSendOrderPaymentInfoSystemAPIExist } from '../../../flowBuilderConstants'

interface saveDataInterface {
    setFlagAdvancedOptions: React.Dispatch<React.SetStateAction<boolean>>,
    fieldsData: any[],
    setAnchorEl: any,
    setFlagSaveDataCollectionPopup: React.Dispatch<React.SetStateAction<boolean>>,
    actionData: any,
    stepAction: any,
    handleClosePopup: () => void
} 

interface flowOutputVariables {
    flow_id: number, 
    variable_key: string, 
}

const SaveDataPopup = (props: saveDataInterface) => {
    const { setFlagAdvancedOptions, actionData, stepAction, handleClosePopup } = props
    const { onChangeCurrentActiveNodeConfig, nodes, setNodes, currentActiveNodeConfig, onBlurOfFallBackOfBtnVar } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { whatsAppWebhookPayloadKeys, getWhatsAppWebhookPayloadKeyApi } = useGenericStore(useShallow((state) => ({
        whatsAppWebhookPayloadKeys: state.whatsAppWebhookPayloadKeys, 
        getWhatsAppWebhookPayloadKeyApi: state.getWhatsAppWebhookPayloadKeyApi
    })))
    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;
    const [payloadKeys, setPayloadKeys] = useState<string[]>([]);
    const [flowOutputVariable, setFlowOutputVariable] = useState<flowOutputVariables[]>([]);

    const innerHeight = window.innerHeight - 350;

    function disabledFlagForSaveBtn() { 
        if(Array.isArray(actionData)){
            // actionData.some((action: any) => !action.action_data.payload_key) ||
            if (actionData.every((action: any) => !action.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_name)) {
                return true
            }
        } else {
            if(!actionData?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id) {
                return true;
            }
        }
        return false
    }

    const getWhatsAppWebhookPayloadKeys = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getWhatsAppWebhookPayloadKeyApi();
        if(!(res?.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
        return res?.data ?? null;
    }

    const getPayloadKeysAndFlowVariables = async () => {
        const isTemplateActionExist = nodes?.find((node: any) => node?.id == currentActiveNodeConfig.nodeId)?.data?.find((data: any) => data?.action_type?.action_type_name == ACTION_TYPE_NAME['TEMPLATE'] || data?.action_type?.action_type_name == ACTION_TYPE_NAME['CAROUSEL_TEMPLATE']);
        const payloadKeys: string[] = [];
        const output_variables: flowOutputVariables[] = [];
        let waCatalogPayloadKeys: whatsAppWebhookPayloadKey[] = [];
        let waPaymentPayloadKeys: whatsAppWebhookPayloadKey[] = [];
        
        if(isTemplateActionExist){
            const template_id = isTemplateActionExist?.action_data?.whatsapp_template?.whatsapp_template_id; 

            const templateDetails = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => String(template?.whatsapp_template_id) == String(template_id));
            const isCustomBtnExist = templateDetails?.whatsapp_template_data?.[0]?.whatsapp_template_button?.filter((btn: whatsappTemplateButton) => btn?.whatsapp_template_button_type_name?.toLowerCase() == "quick reply" && btn?.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_name?.toLowerCase() == "custom");
            if(isCustomBtnExist && isCustomBtnExist?.length > 0){ 


                isCustomBtnExist?.forEach((customBtn) => {
                    const payload_sub_field = customBtn?.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_field_data?.find((field) => field?.field_name?.toLowerCase() == "payload"); 
                    if(payload_sub_field){
                        const fielValue = payload_sub_field?.whatsapp_template_button_sub_type_field_value; 
                        const arrayFieldValue = Array.isArray(fielValue) ? fielValue : JSON.parse(fielValue);
                        arrayFieldValue?.map((fieldValue: any) => { 
                            if(!payloadKeys.find((key) => key == fieldValue?.payload_key)){
                                payloadKeys.push(fieldValue?.payload_key);
                            }
                        })
                    }
                }); 

                // setPayloadKeys(payloadKeys);
            } 

            const isFlowExistInTemplate = templateDetails?.whatsapp_template_flag_flow; 
            if(isFlowExistInTemplate){
                const isFlowButtonExist = templateDetails?.whatsapp_template_data?.[0]?.whatsapp_template_button?.find((btn: whatsappTemplateButton) => btn?.whatsapp_template_button_type_name?.toLowerCase() == "flow" && btn?.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_name?.toLowerCase() == "open form");
                if(isFlowButtonExist){ 


                    isFlowButtonExist?.whatsapp_template_button_data?.[0]?.whatsapp_flow_data?.whatsapp_flow_version_data?.find((version: any) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() == "published")?.whatsapp_flow_variables?.filter((variable: any) => !(variable?.input_variable_flag))?.forEach((flowVariables: any) => {
                        output_variables.push({
                            flow_id: isFlowButtonExist?.whatsapp_template_button_data?.[0]?.whatsapp_flow_data?.whatsapp_flow_id, 
                            variable_key: flowVariables?.variable_key,
                        })
                    }); 

                    // setFlowOutputVariable(output_variables);
                }
            }

            const isCatalogTemplate = templateDetails?.whatsapp_template_type?.name?.toLowerCase() === TEMPLATE_TYPES['CATALOG']?.toLowerCase();
            if(isCatalogTemplate){
                let waWebhookPayloadKeys = whatsAppWebhookPayloadKeys;
                if(!waWebhookPayloadKeys){
                    waWebhookPayloadKeys = await getWhatsAppWebhookPayloadKeys();
                }
                waCatalogPayloadKeys = waWebhookPayloadKeys?.filter((key: whatsAppWebhookPayloadKey) => key?.whatsapp_webhook_payload_key_type === WHATSAPP_WEBHOOK_PAYLOAD_KEY_TYPES['WA_CATALOG']) ?? [];
            }
        } 

        const isSendOrderPaymentSystemAPIExist = isSendOrderPaymentInfoSystemAPIExist(nodes, currentActiveNodeConfig?.nodeId, currentActiveStaticWorkflow);
        if(isSendOrderPaymentSystemAPIExist){
            let waWebhookPayloadKeys = whatsAppWebhookPayloadKeys;
            if(!waWebhookPayloadKeys){
                waWebhookPayloadKeys = await getWhatsAppWebhookPayloadKeys();
            }
            waPaymentPayloadKeys = waWebhookPayloadKeys?.filter((key: whatsAppWebhookPayloadKey) => key?.whatsapp_webhook_payload_key_type === WHATSAPP_WEBHOOK_PAYLOAD_KEY_TYPES['WA_PAYMENT']) ?? [];
        }

        return { payloadKeys, output_variables, waCatalogPayloadKeys, waPaymentPayloadKeys };
    }
    
    const onChangeOfYesClick = async () => { 
        if(!Array.isArray(actionData)){
            const { payloadKeys, output_variables, waCatalogPayloadKeys, waPaymentPayloadKeys } = await getPayloadKeysAndFlowVariables();

            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
                // { 
                //     ...actionData, 
                //     type: "take_value_from_payload_keys" 
                // },
                { 
                    ...actionData, 
                    type: "take_value_from_payload_keys_and_flow_variables", 
                    payload_keys: payloadKeys, 
                    flow_variables: output_variables, 
                    wa_catalog_webhook_payload_keys: waCatalogPayloadKeys,
                    wa_payment_webhook_payload_keys: waPaymentPayloadKeys,
                    already_configured_flow_variables: [],
                },
                {
                    updateType: "editExistingStepAction"
                }
            )
        }
    }

    useEffect(() => {
        (async () => {
            if(Array.isArray(actionData)){
                const { payloadKeys, output_variables, waCatalogPayloadKeys, waPaymentPayloadKeys } = await getPayloadKeysAndFlowVariables();
                
                const userMessagePayloadKeys = actionData?.filter((action) => action?.action_data?.value_type == "user_message_payload");
                const userFlowMessagePayloadKeys = actionData?.filter((action) => action?.action_data?.value_type == "user_flow_message_payload");
                
                const remaining_payload_keys = userMessagePayloadKeys?.length > 0 ? payloadKeys?.filter((payloadKey: string) => !userMessagePayloadKeys?.find((action) => action?.action_data?.payload_key == payloadKey)) : payloadKeys;
                const remaining_output_variables = userFlowMessagePayloadKeys?.length > 0 ? output_variables?.filter((payloadKey : flowOutputVariables) => !userFlowMessagePayloadKeys?.find((action) => action?.action_data?.payload_key == payloadKey?.variable_key)) : output_variables;
                const remaining_wa_catalog_payload_keys = userFlowMessagePayloadKeys?.length > 0 ? waCatalogPayloadKeys?.filter((payloadKey : whatsAppWebhookPayloadKey) => !userFlowMessagePayloadKeys?.find((action) => action?.action_data?.payload_key == payloadKey?.whatsapp_webhook_payload_key_name)) : waCatalogPayloadKeys;
                const remaining_wa_payment_payload_keys = userFlowMessagePayloadKeys?.length > 0 ? waPaymentPayloadKeys?.filter((payloadKey : whatsAppWebhookPayloadKey) => !userFlowMessagePayloadKeys?.find((action) => action?.action_data?.payload_key == payloadKey?.whatsapp_webhook_payload_key_name)) : waPaymentPayloadKeys;
                            
                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, 
                    { 
                        ...actionData, 
                        type: "take_value_from_payload_keys_and_flow_variables", 
                        payload_keys: remaining_payload_keys, 
                        flow_variables: remaining_output_variables, 
                        wa_catalog_webhook_payload_keys: remaining_wa_catalog_payload_keys,
                        wa_payment_webhook_payload_keys: remaining_wa_payment_payload_keys,
                        already_configured_flow_variables: actionData,
                    },
                    {
                        updateType: "editExistingStepAction"
                    }
                )
            }
        })()
    }, []);

    return (
        <Grid container direction={"column"} gap={"20px"} sx={{ zIndex: "1" }}>
            <Grid item className={globalStyles.fullwidth} sx={{padding: "30px 30px 0 30px"}} textAlign={"center"}>
                <span className={popupStyle.popupTitleStyle}>Save Data</span>
            </Grid>
            <Grid item sx={{padding: "0 30px 0 30px"}}>
                <Divider style={{ opacity: "0.3", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
            </Grid>
            <Grid item sx={{padding: "0 30px 0 30px"}} className={globalStyles.fullwidth}>
                <Grid container gap={"8px"} flexWrap={{ xs: "wrap", md: "nowrap" }} alignItems={"center"} justifyContent={"space-between"}>

                    <Grid item className={styles.fieldHeadingStyle} xs={12} md={7}>
                        Extract data from the payload of the output and flow output variables and webhook payload keys? <Required />
                    </Grid>

                    <Grid item className={globalStyles.fullwidth} mt={1} xs={12} md={5}>
                        <Grid container direction={"row"} gap={2} justifyContent={"start"} flexWrap={"nowrap"}>
                            <Grid item>
                                <GlobalButton
                                    buttonText={"Yes"}
                                    className={Array.isArray(actionData) ? 'primaryButtonStyle' : 'borderedButtonStyle'}
                                    sx={{ minWidth: "100px", fontSize: largeScreen ? "13px !important" : "" }} 
                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    onClick={() => onChangeOfYesClick()}
                                />
                            </Grid>
                            <Grid item>
                                <GlobalButton
                                    buttonText={"No"}
                                    className={Array.isArray(actionData) ? 'borderedButtonStyle' : 'primaryButtonStyle'}
                                    sx={{ minWidth: "100px", fontSize: largeScreen ? "13px !important" : "" }} 
                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    onClick={() => {
                                        Array.isArray(actionData) &&
                                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...actionData, type: "take_value_from_text" },
                                                {
                                                    updateType: "editExistingStepAction"
                                                }
                                            )
                                    }
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {Array.isArray(actionData) ?
                <Grid item className={globalStyles.fullwidth} sx={{overflow: "auto", maxHeight: `${innerHeight}px !important`, padding: "0 30px 0 30px" }}>
                    <Grid container gap={1}>
                        <Grid item className={globalStyles.fullwidth} xs={12}>
                            <PayloadFieldTable 
                                stepAction={stepAction} 
                                actionData={actionData} 
                                setFlagDataCollectionPopup={setFlagDataCollectionPopup} 
                            />
                        </Grid>
                        {/* <Grid item sx={{ color: "blue !important", textAlign: "end" }} className={textStyles.fieldHeadingStyle} onClick={() => {
                            onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...actionData, type: "add_new_payload_key" },
                                {
                                    updateType: "editExistingStepAction"
                                }
                            )
                        }}>
                            <Grid container alignItems={"center"} gap={"6px"} justifyContent={"end"}>
                                <Grid item sx={{ display: "flex", cursor: "pointer" }}>
                                    <IconsColor fillColor="blue" iconName="plus" height="16" width="16" />
                                </Grid>
                                <Grid item sx={{ cursor: "pointer" }}>
                                    Add New Payload key
                                </Grid>
                            </Grid>
                        </Grid> */}
                    </Grid>
                </Grid>
                :
                <Grid item sx={{padding: "0 30px 0 30px"}}>
                    <FieldsListOption stepAction={stepAction} setFlagAdvancedOptions={setFlagAdvancedOptions} flagSaveData={true} actionData={actionData} />
                </Grid>
            }
            <Grid item className={globalStyles.fullwidth} mt={2} sx={{padding: "0 30px 30px 30px"}}>
                <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                    <Grid item>
                        <GlobalButton
                            buttonText={"Cancel"}
                            className={'borderedButtonStyle'}
                            sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            onClick={() => {
                                handleClosePopup();
                                onChangeCurrentActiveNodeConfig(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...actionData, type: "cancel_changes" },
                                    {
                                        updateType: "editExistingStepAction"
                                    }
                                )
                            }
                            }
                        />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            buttonText={"Save"}
                            className={'primaryButtonStyle'}
                            sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }}
                            disabled={disabledFlagForSaveBtn() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            onClick={() => {
                                handleClosePopup();
                                onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, { ...actionData, type: "saving_payload_key_changes_in_BE" },
                                    {
                                        updateType: "editExistingStepAction"
                                    }
                                ); 

                                // Change the chatbot_step_action_id and action_save_variable_id of not-configured input variables(Deleted Input Variables).
                                setNodes((prev: any) => {
                                    return prev?.map((node: any) => {
                                        if(node?.id == currentActiveNodeConfig.nodeId){
                                            return {
                                                ...node, 
                                                data: node?.data?.map((data: any) => {
                                                    if(data?.action_type?.action_type_name == "save_variable"){
                                                        return {
                                                            ...data, 
                                                            action_data: Array.isArray(data?.action_data) ? 
                                                                        data?.action_data?.map((actionData: any) => {
                                                                            if(!actionData?.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id){
                                                                                return {
                                                                                    ...actionData, 
                                                                                    chatbot_step_action_id: generateUUID(), 
                                                                                    action_data: {
                                                                                        ...actionData?.action_data, 
                                                                                        action_save_variable_id: generateUUID(),
                                                                                    }
                                                                                }
                                                                            }
                                                                            return actionData;
                                                                        }) : data?.action_data,
                                                        }
                                                    }
                                                    return data;
                                                })
                                            }
                                        }
                                        return node;
                                    })
                                })
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default SaveDataPopup
